module.exports = __webpack_public_path__ + "static/media/space.27746a3c.jpg";